import React, { Fragment } from 'react'
import { makeStyles } from '@mui/styles'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import { dataGridViewerSettings } from './workOrderFillRateConfig'
import { DataGridColumn } from '../../../DataGrid/DataGridColumn'
import { DataGridRow } from '../../../DataGrid/DataGridRow'
import { CellText } from '../../../DataGrid/CellText'
import { WorkOrderFillRateData } from '../../../../interfaces/DashBoard/FillRate'

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    paddingBottom: '0px',
    textAlign: 'center',
    textAlignLast: 'center'
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%'
  },
  content: {
    flex: 'auto',
    paddingBottom: '0px'
  },
  scrollBarFillRate: {
    height: '500px',
    overflowY: 'scroll'
  },
  root2: {
    '&::-webkit-scrollbar': {
      width: '10px',
      backgroundColor: '#F5F5F5'
    },
    '&::-webkit-scrollbar-track': {
      boxShadow: `inset 0 0 6px rgba(0, 0, 0, 0.3)`,
      backgroundColor: '#F5F5F5',
      borderRadius: '10px'
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: '10px',
      backgroundImage:
        '-webkit-gradient(linear,left bottom,left top,color-stop(0.44, rgb(122,153,217)),color-stop(0.72, rgb(73,125,189)),color-stop(0.86, rgb(28,58,148)));'
    }
  }
}))

interface GridElementWorkOrderFillRateProps {
  element: WorkOrderFillRateData
}

export const GridElementWorkOrderFillRate: React.FC<GridElementWorkOrderFillRateProps> =
  ({ element }) => {
    const classes = useStyles()

    return (
      <Fragment>
        <Card className={`${classes.root} `}>
          <div className={classes.details}>
            <CardContent
              className={classes.content}
              style={{ paddingBottom: '0px' }}
            >
              <DataGridRow settings={dataGridViewerSettings}>
                <DataGridColumn
                  datafield='sku'
                  settings={dataGridViewerSettings}
                >
                  <CellText
                    text={
                      element.sku === element.ean13
                        ? element.sku
                        : `${element.sku}/${element.ean13}`
                    }
                  />
                </DataGridColumn>

                <DataGridColumn
                  datafield='name'
                  settings={dataGridViewerSettings}
                >
                  <CellText text={element.name} />
                </DataGridColumn>

                <DataGridColumn
                  datafield='realQty'
                  settings={dataGridViewerSettings}
                >
                  <CellText
                    text={`${element.completedQty.toString()} de ${element.realQty.toString()}`}
                  />
                </DataGridColumn>

                <DataGridColumn
                  datafield='fillrate'
                  settings={dataGridViewerSettings}
                >
                  <CellText text={`${element.fillrate.toString()}%`} />
                </DataGridColumn>
              </DataGridRow>
            </CardContent>
          </div>
        </Card>
      </Fragment>
    )
  }
